var _path, _rect, _rect2, _rect3, _rect4, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXmasGift(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.564 21.3498C15.1477 21.7868 15.8062 22.1284 16.5282 22.3569L5.87684 24.2351L4.39963 24.4956L4.6601 25.9728L6.91752 38.7753L7.178 40.2525L8.65521 39.992L9.43124 39.8552L13.6856 63.983L13.9461 65.4602L15.4233 65.1997L62.129 56.9642L63.6062 56.7038L63.3457 55.2265L59.0913 31.0988L59.8652 30.9623L61.3424 30.7018L61.0819 29.2246L58.8245 16.4221L58.564 14.9449L57.0868 15.2054L46.4354 17.0835C47.0358 16.6218 47.5377 16.0755 47.9368 15.4653C48.926 13.9524 49.219 12.145 48.935 10.4749C48.651 8.80473 47.7771 7.1972 46.3367 6.10627C44.872 4.99696 42.9264 4.5017 40.6805 4.89771C36.9045 5.56352 34.4315 8.30337 32.8391 11.0707C31.9401 12.633 31.2741 14.2842 30.781 15.7458C29.8178 14.541 28.6272 13.2172 27.2481 12.0565C24.8053 10.0007 21.5443 8.27193 17.7683 8.93775C15.5224 9.33376 13.8635 10.4646 12.8666 12.008C11.8862 13.5257 11.6147 15.3352 11.9191 17.0018C12.2234 18.6683 13.117 20.2666 14.564 21.3498ZM40.3444 12.9235L38.9269 13.1734C39.0428 12.9908 39.1597 12.8215 39.2782 12.6656C39.8267 11.9443 40.3045 11.6514 40.7637 11.5705C40.9337 11.5405 40.9948 11.5843 41.0368 11.6216C41.1097 11.6863 41.1998 11.829 41.2232 12.035C41.2455 12.232 41.1977 12.4098 41.1024 12.5406C41.02 12.6539 40.8254 12.8387 40.3444 12.9235ZM19.9724 15.2365C20.4303 15.1558 20.9794 15.2674 21.7422 15.7578C21.9069 15.8637 22.0746 15.9828 22.246 16.1147L20.8291 16.3646C20.3481 16.4494 20.1021 16.3423 19.9859 16.264C19.8516 16.1737 19.7459 16.023 19.6995 15.8303C19.6509 15.6287 19.6868 15.4637 19.7332 15.378C19.7599 15.3286 19.8023 15.2665 19.9724 15.2365ZM33.8907 54.4969L19.7751 56.9859L16.5337 38.6028L30.6492 36.1139L33.8907 54.4969ZM29.3758 28.8919L13.1265 31.7571L12.895 30.4441L29.1443 27.5789L29.3758 28.8919ZM36.3662 26.3054L52.6156 23.4402L52.8471 24.7533L36.5978 27.6185L36.3662 26.3054ZM55.2282 50.7346L41.1126 53.2235L37.8712 34.8404L51.9867 32.3515L55.2282 50.7346Z",
    fill: "#DD4932",
    stroke: "black",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.4026,
    y: 29.3994,
    width: 19.2727,
    height: 3.90909,
    transform: "rotate(-10 11.4026 29.3994)",
    fill: "#CBA487",
    stroke: "black",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.6799,
    y: 25.2949,
    width: 19.2727,
    height: 3.90909,
    transform: "rotate(-10 34.6799 25.2949)",
    fill: "#CBA487",
    stroke: "black",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.3723,
    y: 38.2998,
    width: 16.9091,
    height: 20.4545,
    transform: "rotate(-10 15.3723 38.2998)",
    fill: "#CBA487",
    stroke: "black",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36.3225,
    y: 34.6058,
    width: 16.9091,
    height: 20.4545,
    transform: "rotate(-10 36.3225 34.6058)",
    fill: "#CBA487",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0286 18.2863L25.684 17.4655C24.6919 15.2403 19.7972 11.3031 17.9826 14.6233C16.7496 17.8408 20.0587 18.4574 21.0286 18.2863Z",
    fill: "#CCA350",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.63 14.8302L35.5772 15.7211C35.8264 13.4431 39.4839 8.32986 42.4879 10.5929C44.8605 12.9671 41.6827 14.6446 40.63 14.8302Z",
    fill: "#CCA350",
    stroke: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmasGift);
export default __webpack_public_path__ + "static/media/xmas-gift.42bbe3607eb3ec9b055dcb5788e50cd3.svg";
export { ForwardRef as ReactComponent };